/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";

import { useTranslation } from "react-i18next";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import { ecosystemSlug } from "Config/Config";

//import membership options from json
import EventMembershipStatusOption from "data/Prod/MembershipStatus.json";

const AddNewMemberModal = ({
  roleList,
  afterCloseModalHandler,
  title,
  setShowAlert,
  setAlertMessage,
  setMessageType,
}) => {
  const { t } = useTranslation();
  const params = useParams();

  const token = localStorage.getItem("token");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [userInput, setUserInput] = useState("");
  const [userOptions, setuserOptions] = useState([]);
  const [userValue, setUserValue] = useState(null);
  const [userId, setUserId] = useState(null);
  const [userEmail, setUserEmail] = useState("");
  const [roleValue, setRoleValue] = useState(null);
  const [roleData, setRoleData] = useState(null);
  const [memberShipStatusValue, setMemberShipStatusValue] = useState(null);
  const [memberShipData, setmemberShipData] = useState(null);

  const [isAdding, setIsAdding] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  /* hooks for validation */
  const [validation, setValidation] = useState({
    userWarning: false,
  });

  //** Function for Validation */
  const validationHandler = () => {
    let isValid = true;

    if (!userValue) {
      setValidation((prevState) => ({ ...prevState, userWarning: true }));
      isValid = false;
    }

    return isValid;
  };

  //function for get user details
  const getUserList = async () => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_USERLIST +
        `?token=${token}` +
        `&userstring=${userInput}`;
      //`&roleslug=${userInfo.role.name}`;

      const response = await getData(requestUrl);

      // console.log(response);

      if (response.status) {
        if (response.data.length > 0) {
          setuserOptions(response.data);
        }
      }
    } catch (error) {
      setMessageType("error");
      setAlertMessage(error.message);
      setShowAlert(true);
    }
  };

  //function for get user input
  const userInputHandler = (val) => {
    setUserInput(val);
    setErrorMessage("");
  };

  //function user Selection
  const userSelectionHandler = (val) => {
    setErrorMessage("");
    if (val) {
      setUserValue(val);
      val._id ? setUserId(val._id) : setUserId(null); // if new user or other than contact user email is added
      val.email ? setUserEmail(val.email) : setUserEmail(val.value); // if new user or other than contact, set value as email
    } else {
      setUserValue(null);
      setUserId(null);
      setUserEmail("");
      setuserOptions([]);
    }
  };

  //function for select role
  const roleSelectionHandler = (val) => {
    setRoleValue(val);
    setRoleData(val.value);
    setErrorMessage("");
  };

  //function for select memebership status
  const memberShipStatusSelectionHandler = (val) => {
    setMemberShipStatusValue(val);
    setmemberShipData(val.value);
    setErrorMessage("");
  };

  //function for reset user select
  const resetUserSelect = () => {
    setUserValue(null);
    setuserOptions([]);
  };

  //function for reset role select
  const resetRoleSelect = () => {
    setRoleValue(null);
    setRoleData(null);
  };

  //function for reset memberstatus select
  const resetMemberStatusSelect = () => {
    setMemberShipStatusValue(null);
    setmemberShipData(null);
  };

  //** Function for add/invite event member
  const addProjectMemberHandler = async () => {
    if (validationHandler()) {
      setIsAdding(true);
      try {
        let projectMemberData = {
          user: userId,
          project: params.id ? params?.id : null,
          role: roleData,
          useremail: userEmail,
          moderatorstatus: memberShipData,
          //memberstatus: "1",
          projectdetailsurl: window.location.href,
          title,
        };

        console.log("MemberData---->", projectMemberData);

        let requestUrl =
          url.API_BASE_URL +
          url.API_ADD_PROJECT_MEMBER +
          `?token=${token}&ecosystemslug=${ecosystemSlug}`;

        const response = await postData(requestUrl, projectMemberData);

        setIsAdding(false);
        // console.log(response);

        if (response.status) {
          setMessageType("success");
          resetHandler();

          //hide member modal
          let bootstrapModal = document.querySelector("#addProjectMember");
          let modal = bootstrap.Modal.getInstance(bootstrapModal);
          modal.hide();

          //call member list api function
          afterCloseModalHandler();
        } else {
          setMessageType("error");
          setErrorMessage(response.message);
        }
        setAlertMessage(response.message);
      } catch (error) {
        console.log(error.message);
      }
    } else {
      setMessageType("error");
      setAlertMessage("Please fill up the required fields");
      setErrorMessage(t("Please fill up the required fields"));
    }

    setShowAlert(true);
  };

  //** Function for reset
  const resetHandler = () => {
    resetUserSelect();
    // resetRoleSelect();
    // resetMemberStatusSelect();
    roleList.map((roleData) => {
      if (roleData.label == "Member") {
        roleSelectionHandler(roleData);
      }
    });

    EventMembershipStatusOption.map((statusData) => {
      if (statusData.value == "0") {
        memberShipStatusSelectionHandler(statusData);
      }
    });
    setUserInput("");
    setUserId(null);
    setUserEmail("");
    setErrorMessage("");
    setValidation({
      userWarning: false,
    });
  };

  useEffect(() => {
    roleList.map((roleData) => {
      if (roleData.label == "Member") {
        roleSelectionHandler(roleData);
      }
    });

    EventMembershipStatusOption.map((statusData) => {
      if (statusData.value == "0") {
        memberShipStatusSelectionHandler(statusData);
      }
    });
  }, [roleList]);

  useEffect(() => {
    if (userInput.length > 3) {
      getUserList();
    }
  }, [userInput]);

  const optionsToShow = userOptions.length > 0 ? userOptions : [];

  return (
    <div
      className="modal fade"
      id="addProjectMember"
      tabIndex="-1"
      aria-labelledby="addProjectMember"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content bg-white border-0 rounded-15">
          <div className="modal-header p-4 pb-0 border-0">
            {/* <!-- ========== Start modal title  ========== --> */}
            <h2 className="fw-bold mb-0" id="addMemberLabel">
              {t("Invite / Add Member")}
            </h2>
            {/* <!-- ========== End modal title  ========== --> */}

            {/* <!-- ========== Start modal close button ========== --> */}
            <button
              type="button"
              className="btn-close p-0 bg-gray-200 rounded-circle shadow-none m-0"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={resetHandler}
            ></button>
            {/* <!-- ========== End modal close button ========== --> */}
          </div>
          <div className="modal-body p-4">
            <form onSubmit={(e) => e.preventDefault()}>
              {/* ----- user select section start ----- */}
              <div className="form-group mb-4">
                <label
                  htmlFor="memberName"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Invite app users / guest (search by name, email)")}
                </label>
                <div className="d-flex align-items-center">
                  <CreatableSelect
                    isClearable
                    className="w-100"
                    placeholder={t("Search by name, email")}
                    options={optionsToShow}
                    value={userValue}
                    onChange={(val) => {
                      userSelectionHandler(val);
                      setValidation((prevState) => ({
                        ...prevState,
                        userWarning: false,
                      }));
                      setErrorMessage("");
                    }}
                    onInputChange={(val) => {
                      userInputHandler(val);
                      setValidation((prevState) => ({
                        ...prevState,
                        userWarning: false,
                      }));
                      setErrorMessage("");
                    }}
                  />
                </div>
                {/* <!-- ========== Start user validation Section ========== --> */}
                {validation.userWarning && (
                  <p className="text-danger fw-semibold">
                    * {t("Please type or select user name or email")}
                  </p>
                )}
                {/* <!-- ========== End user validation Section ========== --> */}
              </div>
              {/* ----- user select section end ----- */}

              {/* ----- role select section start ----- */}
              <div className="form-group mb-4">
                <label
                  htmlFor="role"
                  className="d-block fs-sm fw-semibold mb-2"
                >
                  {t("Role")}
                </label>
                <div className="d-flex align-items-center">
                  <Select
                    className="w-100"
                    placeholder={t("Select role")}
                    options={roleList}
                    value={roleValue}
                    onChange={(val) => roleSelectionHandler(val)}
                  />
                  {/* <Link to="#" className="ms-1" onClick={resetRoleSelect}>
                    <span className="d-block material-symbols-outlined">
                      delete
                    </span>
                  </Link> */}
                </div>
              </div>
              {/* ----- role select section end ----- */}

              {/* <!-- ========== Start button and error message Section ========== --> */}
              <div className="action d-flex align-items-center gap-3">
                {/* <!-- ========== Start cancel modal button ========== --> */}
                <button
                  className="btn btn-outline-primary"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  {t("Cancel")}
                </button>
                {/* <!-- ========== End cancel modal button ========== --> */}

                {/* <!-- ========== Start error message Section ========== --> */}
                {errorMessage == "" ? null : (
                  <p className="text-danger fw-semibold">* {errorMessage}</p>
                )}
                {/* <!-- ========== End error message Section ========== --> */}

                {/* <!-- ========== Start save button Section ========== --> */}
                <button
                  type="button"
                  className="btn btn-primary ms-auto"
                  onClick={addProjectMemberHandler}
                  disabled={isAdding ? true : false}
                  style={{
                    cursor: isAdding ? "not-allowed" : "pointer",
                  }}
                >
                  {t("Send Invite")}
                  {isAdding && (
                    <div
                      className="mx-2 spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </button>
                {/* <!-- ========== End save button Section ========== --> */}
              </div>
              {/* <!-- ========== End button and error message Section ========== --> */}
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddNewMemberModal;
